<template>
  <div id="app">
    <Header />
      <div class="content">
        <div v-if="error">
          <Alert :message="error" variant="danger" />
        </div>
        <div v-else>
            <EmailRegistration :buildingslist="buildingslist" :regionslist="regionslist" />
        </div>
      </div>
    <Footer />
  </div>
</template>

<script>
import axios from 'axios';
import Alert from './Alert.vue'
import Header from './Header.vue'
import Footer from './Footer.vue'
import EmailRegistration from './EmailRegistration.vue'

export default {
  name: 'app',
  data: () => ({
    error: "",
    buildingslist: [],
    regionslist: []
  }),
  mounted () {

    if (/*@cc_on!@*/false || !!document.documentMode)  // If Internet Explorer <= 11
    {
      if (this.$i18n.locale === 'fr') {
        this.error = "INTERNET EXPLORER N'EST PAS SUPPORTÉ. VEUILLEZ UTILISER CHROME, FIREFOX OU MICROSOFT EDGE";
      }
      else {
        this.error = "INTERNET EXPLORER IS NOT SUPPORTED. PLEASE USE CHROME, FIREFOX OR MICROSOFT EDGE";
      }    
    }

    else {
      let url = process.env.VUE_APP_WHERE;

      axios.post(url, {request: "getBuildingList"}, { headers: {'Content-Type': 'application/json'}})
         .then((response)  => {
           if (response.data.building && response.data.regions) {
             this.buildingslist = response.data.building;
             this.regionslist = response.data.regions;
           }

         })
         .catch((error)  => {
           this.error = error;
         });
    }
  },
  components: {
    Alert,
    Header,
    Footer,
    EmailRegistration
  }
}
</script>
